export enum GeneralAvailabilityScreenNames {
  MAIN = 'general-availabilities-nav',
  GENERAL_AVAILABILITY = 'general-availability',
  CHOOSE_AVAILABILITY = 'choose-general-availability',
}
